export enum ProductTypes {
  glassClear = 'Glass Clear',
  glassSmoke = 'Glass Smoke',
  glassDark = 'Glass Dark',
  laserCutAgama = 'Laser Cut Agama',
  laserCutBound = 'Laser Cut Bound',
  laserCutCubist = 'Laser Cut Cubist',
  laserCutPisces = 'Laser Cut Pisces',
  laserCutRhythm = 'Laser Cut Rhythm',
  laserCutSeagrass = 'Laser Cut Seagrass',
  laserCutSverra = 'Laser Cut Sverra',
  laserCutTrillium = 'Laser Cut Trillium',
  laserCutPulse = 'Laser Cut Pulse',
  // Kerri Kelly Collection — placeholder product names until final designs arrive
  laserCutKelly1 = 'Laser Cut Kelly 1',
  laserCutKelly2 = 'Laser Cut Kelly 2',
  laserCutKelly3 = 'Laser Cut Kelly 3',
  laserCutKelly4 = 'Laser Cut Kelly 4',
  laserCutKelly5 = 'Laser Cut Kelly 5',
  laserCutKelly6 = 'Laser Cut Kelly 6',
  laserCutKelly7 = 'Laser Cut Kelly 7',
  laserCutKelly8 = 'Laser Cut Kelly 8',
  laserCutKelly9 = 'Laser Cut Kelly 9',
  steelMeshAllure = 'Steel Mesh Allure',
  steelMeshDazzle = 'Steel Mesh Dazzle',
  steelMeshMetropolitan = 'Steel Mesh Metropolitan',
  steelMeshHorizon = 'Steel Mesh Horizon'
}



// WEBPACK FOOTER //
// ./src/app/models/2d3d/product-types.ts